import { Search } from '@mui/icons-material';
import { InputAdornment, TextField } from '@mui/material';
import { HTMLAttributes } from 'react';

import { tApp } from '@frontend/locales';

export interface SearchBarProps {
  onSearch(input: string): void;
  placeholder?: string;
  /** Makes the field controlled. Omit to keep the previous uncontrolled behaviour. */
  value?: string;
  inputMode?: HTMLAttributes<HTMLInputElement>['inputMode'];
}

export const SearchBar = (props: SearchBarProps) => {
  return (
    <TextField
      variant="outlined"
      fullWidth
      size="small"
      value={props.value}
      placeholder={props.placeholder ?? tApp.headers.search()}
      slotProps={{
        htmlInput: {
          inputMode: props.inputMode,
        },
        input: {
          sx: {
            height: 48,
          },
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        },
      }}
      onChange={(e) => props.onSearch?.(e.target.value)}
    />
  );
};
